import { format, isDate } from 'date-fns'
import { isEmpty } from 'lodash'
import {
  change,
  getFormSyncWarnings,
  getFormValues,
  stopAsyncValidation,
  updateSyncWarnings,
} from 'redux-form'
import * as Effects from 'redux-saga/effects'
import {
  ICalculateEndPrice,
  toggleCalculate,
} from '../../../actions/bookingCalendar/reservationModal/calculateEndPrice'
import { callFetch } from '../../../actions/fetch'
import { fireToastError } from '../../../actions/toasts/fireToast'
import dollar from '../../../actions/toasts/icons/dollar'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import i18n from '../../../i18n'
import { FeedingType } from '../../../models/Object'
import { IEndPrice } from '../../../models/Price'
import fetchEndPrice from '../../../models/Price/fetchEndPrice'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import { getUserPriceListVersion } from '../../../reducers/userObject/selectors/object'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'

function redirect(priceList) {
  return () =>
    window.open(priceList === '1' ? `/price/edit` : '/price/set', '_blank')
}

function* calculate(action: ICalculateEndPrice) {
  yield Effects.put(toggleCalculate(true))
  const warrings = yield Effects.select(getFormSyncWarnings(action.form))

  const getForm = getFormValues(action.form)
  const values: ICreateReservationFormValues = yield Effects.select(getForm)

  if (
    values.priceType === 1 ||
    values.priceType === 2 ||
    values.priceType === 3
  ) {
    const localAction = {
      form: action.form,
      type: 'recalculate end price',
    }
    yield Effects.put(localAction)
    yield Effects.put(toggleCalculate(false))
    yield Effects.put(updateSyncWarnings(action.form, {}, {}))
    return
  }

  if (
    !isDate(values.dateFrom) ||
    !isDate(values.dateTo) ||
    !(values.adultsCount > 0) ||
    !values.roomId
  ) {
    const errors = {}
    if (!(values.adultsCount > 0)) {
      errors['adultsCount'] = 'reservation_error_wrong_number_of_people'
    }
    if (!isDate(values.dateTo)) {
      errors['dateTo'] = 'reservation_no_date_error'
    }
    if (!values.roomId) {
      errors['roomId'] = 'BBO_963_select_room'
    }

    yield Effects.put(stopAsyncValidation(action.form, errors))
    yield Effects.put(
      fireToastError(
        i18n.t('reservation_error_get_price_check_form_errors'),
        null,
        'Event',
        'calculateError',
      ),
    )
    yield Effects.put(toggleCalculate(false))
    return
  }

  try {
    const actionNames = fetchActionsName(ActionNames.CalculatePrice)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchEndPrice),
      ),
    ])

    const endPrice: IEndPrice[] = yield Effects.call(
      service,
      values.roomId,
      format(values.dateFrom, 'YYYY-MM-DD'),
      format(values.dateTo, 'YYYY-MM-DD'),
      values.adultsCount,
      values.childrenCount ? values.childrenCount : 0,
      !isEmpty(values.children)
        ? values.children.map(kid => kid.age).join(',')
        : 0,
      values.feeding ? values.feeding : FeedingType.WithoutFood,
      Number(values.adultsCount) + Number(values.childrenCount),
    )

    if (!warrings.endPrice) {
      yield Effects.put(
        change(
          action.form,
          'advancePaymentPrice',
          Number(endPrice[0].provision).toFixed(2),
        ),
      )
      yield Effects.put(
        change(
          action.form,
          'payOnPlacePrice',
          (
            Number(endPrice[0].endPrice) - Number(endPrice[0].provision)
          ).toFixed(2),
        ),
      )
    }

    yield Effects.all([
      Effects.put(
        change(
          action.form,
          'endPrice',
          Number(endPrice[0].endPrice).toFixed(2),
        ),
      ),
      Effects.put(
        change(
          action.form,
          'pricePerPerson',
          Number(endPrice[0].endPrice) /
            Number(values.daysCount) /
            (Number(values.adultsCount) + Number(values.childrenCount)),
        ),
      ),
      Effects.put(
        change(action.form, 'localTax', Number(endPrice[0].tax).toFixed(2)),
      ),
      Effects.put(
        change(
          action.form,
          'pricePerDay',
          (Number(endPrice[0].endPrice) / Number(values.daysCount)).toFixed(2),
        ),
      ),
    ])

    yield Effects.put(toggleCalculate(false))
    yield Effects.put(updateSyncWarnings(action.form, {}, {}))
    yield Effects.put(change(action.form, 'priceType', 0))
  } catch (e) {
    yield Effects.put(toggleCalculate(false))
    const priceList = yield Effects.select(getUserPriceListVersion)
    if (e.message === '404') {
      yield Effects.put(
        fireToastError(
          i18n.t('BBO_977_pricing_configuration_missing'),
          null,
          'Event',
          'calculateListError',
          true,
          i18n.t('z677_price_list_configuration'),
          redirect(priceList),
          dollar(),
        ),
      )
    }
  }
}

export default function*() {
  yield Effects.debounce(
    200,
    ReservationModalActions.CalculateEndPrice,
    calculate,
  )
}
